import { ALL_BUSINESS_UNIT_ID, BUSINESS_UNIT_URL_PARAM, SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY } from '../constants/BusinessUnits';
import { getBusinessUnitLocalStorage } from './businessUnitsUtils';
import { setLocalStorage } from './localstorage';
import { getUrlParamValue } from './urlParamHelpers';
export function getCurrentBusinessUnitId({
  portalId
}) {
  const rawUrlParamBusinessUnit = getUrlParamValue(BUSINESS_UNIT_URL_PARAM);
  let urlParamBusinessUnit;
  if (rawUrlParamBusinessUnit && rawUrlParamBusinessUnit !== ALL_BUSINESS_UNIT_ID) {
    urlParamBusinessUnit = parseInt(rawUrlParamBusinessUnit, 10);
  }
  let localStorageBusinessUnits = getBusinessUnitLocalStorage();

  //handles previous data structure can eventually be deleted
  if (typeof localStorageBusinessUnits === 'string' || typeof localStorageBusinessUnits === 'number') {
    localStorageBusinessUnits = {
      [portalId]: localStorageBusinessUnits
    };
    setLocalStorage(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY, localStorageBusinessUnits);
  }
  const currentBusinessUnit = urlParamBusinessUnit || localStorageBusinessUnits[portalId];
  if (!currentBusinessUnit) {
    return 0;
  }
  return currentBusinessUnit;
}
export function getCurrentBusinessUnitFromBusinessUnits({
  businessUnits,
  portalId
}) {
  if (!businessUnits.length) {
    return undefined;
  }
  const curentBusinessUnit = businessUnits.find(unit => unit.id === getCurrentBusinessUnitId({
    portalId
  }));
  return curentBusinessUnit || businessUnits.find(bu => bu.id === 0);
}